<ion-grid fixed [class]="gameType">
  <ion-row
    class="ion-no-padding ion-no-margin"
    [ngClass]="{ retro: isRetro }"
    *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]"
  >
    <ion-col class="ion-no-padding ion-no-margin" [size]="12 / tens.length" *ngFor="let j of tens; let k = index">
      <ion-fab-button
        *ngIf="gameType === 'tris' || i + j + 1 <= limit"
        [disabled]="gameType !== 'tris' && isDisabled(i, j, k)"
        [ngClass]="{ selected: isSelected(i, j, k), disabled: isDisabled(i, j, k) }"
        size="small"
        (click)="select(i, j, k)"
      >
        <!-- <ion-icon *ngIf="gameType==='tris' && isDisabled(i,j,k)" name="checkmark-outline"></ion-icon> -->
        <!-- <span *ngIf="gameType!=='tris' || !isDisabled(i,j,k)">{{ i + j + (gameType === 'tris' ? 0 : 1) }}</span> -->
        <span>{{ i + j + (gameType === 'tris' ? 0 : 1) }}</span>
      </ion-fab-button>
    </ion-col>
  </ion-row>
</ion-grid>
